module.exports = __webpack_public_path__ + "img/item21.7f13ac20.png";